"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicSupportMessageSchema = void 0;
const zod_1 = require("zod");
// API verbatim schema (source of truth: apps/api/src/common/schemas.ts)
exports.publicSupportMessageSchema = zod_1.z.object({
    name: zod_1.z.string().min(2).max(255),
    surname: zod_1.z.string().min(2).max(255),
    email: zod_1.z.string().email().max(255),
    phone: zod_1.z.string().min(10).max(50),
    subject: zod_1.z.string().min(3).max(500),
    message: zod_1.z.string().min(10),
});
//# sourceMappingURL=support.js.map